import { ReactNode } from "react";

const ButtonRow: React.FC<ButtonRowProps> = ({ children, alignment = 'center', className = '' }) => (
    <div className={`button-row ${alignment} ${className}`}>{children}</div>
);

interface ButtonRowProps {
    children: ReactNode;
    alignment?: string;
    className?: string;
}

export default ButtonRow;
